import { useState } from "react";
import { post } from "../networking/RequestService";
import { toast } from "react-toastify";
import { apiErrorText } from "app/popleads/networking/apiErrorText";

const useActivityPreview = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [preview, setPreview] = useState(null);

    const getActivityPreview = async (activityId, type = "all") => {
        if (!activityId) {
            toast.error("Activity ID is required.");
            return;
        }

        setLoading(true);
        setError(null);
        try {
            const response = await post({
                fn: "getActivityPreview",
                activityId: activityId,
                type: type,
            });
            setPreview(response.data);
            return response.data;
        } catch (err) {
            toast.error(apiErrorText(err));
            setError(err);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return { loading, error, preview, getActivityPreview };
};

export default useActivityPreview;
